import { SvgIcon, SvgIconProps } from '@mui/material'

export function HomeIcon(props: SvgIconProps) {
  return (
    <SvgIcon role="img" viewBox="0 0 16 16" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.68769 0.942909C7.8703 0.796822 8.12978 0.796822 8.31239 0.942909L14.9791 6.27624C15.0977 6.37113 15.1667 6.51479 15.1667 6.66668V14.6667C15.1667 14.9428 14.9429 15.1667 14.6667 15.1667H10.6667C10.3906 15.1667 10.1667 14.9428 10.1667 14.6667V9.16668H5.83337V14.6667C5.83337 14.9428 5.60952 15.1667 5.33337 15.1667H1.33337C1.05723 15.1667 0.833374 14.9428 0.833374 14.6667V6.66668C0.833374 6.51479 0.902419 6.37113 1.02103 6.27624L7.68769 0.942909ZM1.83337 6.90699V14.1667H4.83337V8.66668C4.83337 8.39053 5.05723 8.16668 5.33337 8.16668H10.6667C10.9429 8.16668 11.1667 8.39053 11.1667 8.66668V14.1667H14.1667V6.90699L8.00004 1.97366L1.83337 6.90699Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 10.8333C8.27614 10.8333 8.5 11.0572 8.5 11.3333V14.6667C8.5 14.9428 8.27614 15.1667 8 15.1667C7.72386 15.1667 7.5 14.9428 7.5 14.6667V11.3333C7.5 11.0572 7.72386 10.8333 8 10.8333Z"
        fill="currentColor"
      />

    </SvgIcon>
  )
}

export default HomeIcon